class Watermark {
  constructor(options) {
    this.init(options)
  }
  init(options) {
    // 画布的Id
    this.id = options.id || '1.23452384164.123412416'
    // 需要水印的元素
    this.container = options.container || document.body
    // 水印字段
    this.mark = options.mark
    this.markOption = {
      // 旋转角度
      rotate: -15,
      // 字体大小
      font: '14px Vedana',
      //设置填充绘画的颜色、渐变或者模式
      fillStyle: 'rgba(200, 200, 200, 0.40)',
      //设置文本内容的当前对齐方式
      textAlign: 'left',
      //设置在绘制文本时使用的当前文本基线
      textBaseline: 'Middle',
      ...options.markRotate
    }
    this.canvas = this.createCanvas(
      options.width,
      options.height
    );
    this.context = this.canvas.getContext("2d");
    this.initMark()
  }

  initMark() {
    this.removeMark()
    const {rotate, font, fillStyle, textAlign, textBaseline} = this.markOption
    this.context.rotate(rotate*Math.PI / 180)
    this.context.font = font;
    //设置填充绘画的颜色、渐变或者模式
    this.context.fillStyle = fillStyle;
    //设置文本内容的当前对齐方式
    this.context.textAlign = textAlign;
    //设置在绘制文本时使用的当前文本基线
    this.context.textBaseline = textBaseline;
    //在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
    this.context.fillText(this.mark, 0, this.canvas.height);
    // this.context.fillText(this.mark, this.canvas.width / 10, this.canvas.height / 2);
    let div = document.createElement('div');
    const {width, height} = this.container.getBoundingClientRect()
    div.id = this.id;
    div.style.pointerEvents = 'none';
    div.style.position = 'absolute';
    div.style.top = '0px';
    div.style.zIndex = '100000';
    div.style.left = '0px';
    div.style.width = width + 'px';
    div.style.height = height + 'px';
    div.style.background = 'url(' + this.canvas.toDataURL('image/png') + ') left top repeat';
    this.container.appendChild(div);
  }
  // 获取水印的实际宽度
  getTextWith() {
    const {font} = this.markOption
    // const {rotate, font, fillStyle, textAlign, textBaseline} = this.markOption
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    // context.rotate(rotate * Math.PI / 180);
    context.font = font;
    // //设置填充绘画的颜色、渐变或者模式
    // context.fillStyle = fillStyle;
    // //设置文本内容的当前对齐方式
    // context.textAlign = textAlign;
    // //设置在绘制文本时使用的当前文本基线
    // context.textBaseline = textBaseline;
    const elem = context.measureText(this.mark)
    return elem.width
  }
  createCanvas(width, height) {
    const canvas = document.createElement("canvas");
    const getWidth = this.getTextWith() + 20
    const defaultWidth = width || 100
    const maxWidth = getWidth > defaultWidth ? getWidth : defaultWidth
    canvas.width = maxWidth;
    canvas.height = height || 100;
    return canvas;
  }

  removeMark() {
    if (document.getElementById(this.id) !== null) {
      this.container.removeChild(document.getElementById(this.id));
    }
  }
}
export default Watermark